import Vue from 'vue';
import Vuex from 'vuex';
import SecureLS from 'secure-ls';
import createPersistedState from 'vuex-persistedstate';
import camelCase from 'lodash/camelCase';
import { loadVuexModules } from '@/lib/loader';

const ls = new SecureLS({ isCompression: false });
// Create a new Vuex instance
Vue.use(Vuex);
// Load all vuex modules within the project
const allModules = loadVuexModules();

const store = new Vuex.Store({
  modules: {
    ...allModules
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key)
      }
    })
  ]
});

export default store;
